<template>
  <v-card class="login-wrap mx-auto pa-3" :class="{'mt-5': $vuetify.breakpoint.mdAndUp}" max-width="430">
    <v-card-text>
      <div class="d-flex justify-space-between">
        <div class="card-title">{{ $t('login.welcome') }}</div>
        <div class="close-btn" @click="navigatePush('home')">&times;</div>
      </div>
      <div class="mt-7 mb-1">
        <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
          <ValidationProvider :name="$t('labels.email')" rules="required|email" v-slot="{ errors }">
            <v-text-field
              class="login-text-field mb-1"
              v-model="form.username"
              single-line
              outlined
              :label="$t('labels.email')"
              background-color="white"
              flat
              dense
              ref="username"
              :error-messages="errors[0]"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider :name="$t('labels.pwd')" rules="required" v-slot="{ errors }">
            <v-text-field
              class="login-text-field"
              v-model="form.password"
              single-line
              outlined
              :label="$t('labels.pwd')"
              background-color="white"
              flat
              dense
              :error-messages="errors[0]"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="passes(loginSubmit)"
            ></v-text-field>
          </ValidationProvider>
          <div class="text-right">
            <router-link to="/forget-pwd" class="forget-btn font-13">{{ $t('login.forgotPwd') }}</router-link>
          </div>
          <div class="btns-wrap mt-4">
            <v-btn
              class="btn-common"
              block
              x-large
              :loading="commitLoading"
              :large="$vuetify.breakpoint.xsOnly"
              @click="passes(loginSubmit)"
            >
              {{ $t('actions.login') }}
            </v-btn>
            <div class="text-center font-12 mt-3 mb-3">{{ $t('labels.or') }}</div>
            <v-btn
              class="btn-yellow"
              block
              x-large
              :large="$vuetify.breakpoint.xsOnly"
              @click="showMaxRegisterModal"
            >
              <img
                class="btn-mxw-logo"
                :src="maxWalletLogo"
                alt="max-wallet"
                height="40px"
              />
              {{ $t('actions.loginMaxWallet') }}
            </v-btn>
          </div>
        </ValidationObserver>
      </div>
    </v-card-text>
    <v-card-actions class="justify-center mb-2">
      <div class="font-12">
        {{ $t('login.dontHaveAcc') }}
        <router-link to="/register">{{ $t('login.registerForFree') }}</router-link>
      </div>
    </v-card-actions>
    <MaxRegisterModal
      v-if="maxWalletModalShow"
      :show.sync="maxWalletModalShow"
      :pkg-type="maxWalletPkgType"
      :title="$t('max.register.title.login')"
      :desc="$t('max.register.desc.login')"
    />
  </v-card>
</template>
<script>
import index from './login';
export default index;
</script>

<style lang="stylus" scoped>
@import '../common.styl'
</style>
